module.exports = __webpack_public_path__ + "static/media/3.499b8eb5.jpg";